<div class="row p-1">
    <div class="col-12 pageTitle">
        <h2>&nbsp;&nbsp;&nbsp;{{title}}</h2>
    </div>
</div>

<div>
    <form [formGroup]="RolesForm" (ngSubmit)="save()">
        <div class="card">
            <div class="p-fluid formgrid grid mt-3">
                <div class="field col-12 md:col-6">
                    <span class="p-float-label">
                        <input id="rname"
                               type="text"
                               style="font-size: 13px"
                               class="mt-1"
                               appFormErrorMessages
                               pInputText
                               formControlName="roleName" />
                        <label for="float-input" style="font-size: 16px">
                            <span class="required-asteric"> * </span> Role Name
                        </label>
                    </span>
                </div>
                <div class="field col-12 md:col-6">
                    <span class="p-float-label">
                        <input id="rdescription"
                               type="text"
                               style="font-size: 13px"
                               class="mt-1"
                               pInputText
                               formControlName="roleDescription" />
                        <label for="float-input" style="font-size: 16px">
                            Role Description
                        </label>
                    </span>
                </div>
            </div>
            <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-4 mt-3 ml-3">
                    <p-checkbox formControlName="checkAll"
                                value="Y"
                                name="CheckUncheck"
                                binary="true"
                                label="Select All"
                                (click)="checkUncheckAll()"></p-checkbox>
                </div>
            </div>

            <!--<p-panel header="General" [toggleable]="true" class="blueGradient">-->



            <h5 class="col-3 md:col-3 lg:col-2 xl:col-2 blueBar mb-4 pl-3 r-2">General</h5>
            <div class="p-fluid formgrid grid ml-5">
                <div class="field col-12 md:col-3" *ngIf="showAppointment">




                    <p-checkbox #Roles
                                name="Appointment"
                                value="Y"
                                label="Appointment"
                                binary="true"
                                formControlName="appointment"></p-checkbox>
                </div>


                <div class="field col-12 md:col-3">



                    <p-checkbox #Roles
                                name="ptsearch"
                                value="Y"
                                label="Patient Search"
                                binary="true"
                                formControlName="patientSearch"></p-checkbox>
                </div>
                <!--<div class="field col-12 md:col-4" *ngIf="showSignOffQueue">
        <p-checkbox #Roles name="signoff" value="Y" label="SignOffQueue" binary="true" formControlName="signOffQueue"></p-checkbox>
    </div>
    <div class="field col-12 md:col-4" *ngIf="showTasks">
        <p-checkbox #Roles name="tasks" value="Y" label="Tasks" binary="true" formControlName="tasks"></p-checkbox>
    </div>-->
                <!--<div class="field col-12 md:col-4">
        <p-checkbox #Roles name="chngpwd" value="Y" label="Change Password" binary="true" formControlName="changePassword"></p-checkbox>
    </div>-->



                <div class="field col-12 md:col-3" *ngIf="showReports">

                    <p-checkbox #Roles
                                name="viewReports"
                                value="Y"
                                label="View Reports"
                                binary="true"
                                formControlName="viewReports"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3" *ngIf="showReports">

                    <p-checkbox #Roles
                                name="viewPatientReports"
                                value="Y"
                                label="View Patient Reports"
                                binary="true"
                                formControlName="viewPatientReports"></p-checkbox>
                </div>

                <!--<div class="field col-12 md:col-3">


        <p-checkbox #Roles
                    name="patientDemographics"
                    value="Y"
                    label="Patient Demographics"
                    binary="true"
                    formControlName="patientDemographics"></p-checkbox>
    </div>-->


            </div>
            <!--</p-panel>-->
            <!--<p-panel header="Administrator " [toggleable]="true">-->

            <h5 class="col-3 md:col-3 lg:col-2 xl:col-2 blueBar mb-4 pl-3 r-2">Administrator</h5>
            <div class="p-fluid formgrid grid ml-5">

                <div class="field col-12 md:col-3">
                    <p-checkbox #Roles
                                name="manageusers"
                                value="Y"
                                label="Manage Users"
                                binary="true"
                                formControlName="manageUsers"></p-checkbox>
                </div>

                <div class="field col-12 md:col-3">
                    <p-checkbox #Roles
                                name="manageroles"
                                value="Y"
                                label="Manage Roles"
                                binary="true"
                                formControlName="manageRoles"></p-checkbox>
                </div>

                <div class="field col-12 md:col-3">
                    <p-checkbox #Roles
                                name="manageUserPractices"
                                value="Y"
                                label="Manage Users Practices"
                                binary="true"
                                formControlName="manageUserPractices"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3">
                    <p-checkbox #Roles
                                name="managePracticeConfig"
                                value="Y"
                                label="Manage Practice Config"
                                binary="true"
                                formControlName="managePracticeConfig"></p-checkbox>
                </div>

                <div class="field col-12 md:col-3" *ngIf="showReports">
                    <p-checkbox #Roles
                                name="managereports"
                                value="Y"
                                label="Manage Reports"
                                binary="true"
                                formControlName="manageReports"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3">
                    <p-checkbox #Roles
                                name="managenotes"
                                value="Y"
                                label="Manage Notes"
                                binary="true"
                                formControlName="manageNotes"></p-checkbox>
                </div>





                <div class="field col-12 md:col-3" *ngIf="showpatientArchive">
                    <p-checkbox #Roles
                                name="patientarchive"
                                value="Y"
                                label="Patient Archive"
                                binary="true"
                                formControlName="patientArchive"></p-checkbox>
                </div>
                  <div class="field col-12 md:col-3">
                    <p-checkbox #Roles
                                name="manageGlobalSetting"
                                value="Y"
                                label="Global Settings"
                                binary="true"
                                formControlName="manageGlobalSetting"></p-checkbox>
                </div>

                  <ng-container *ngIf="isGlobalAdmin">
                      <div class="field col-12 md:col-3">
                          <p-checkbox #Roles
                                      name="globalAdminPrivilege"
                                      value="Y"
                                      label="Global Admin"
                                      binary="true"
                                      formControlName="globalAdminPrivilege" style="font-weight:bold"></p-checkbox>
                      </div>

                      <div class="field col-12 md:col-3">
                          <p-checkbox #Roles
                                      name="manageGlobalConfig"
                                      value="Y"
                                      label="Manage Global Config"
                                      binary="true"
                                      formControlName="manageGlobalConfig"></p-checkbox>
                      </div>

                      <div class="field col-12 md:col-3">
                          <p-checkbox #Roles
                                      name="securityquestions"
                                      value="Y"
                                      label="Security Questions"
                                      binary="true"
                                      formControlName="securityQuestions"></p-checkbox>
                      </div>
                      <div class="field col-12 md:col-3">
                          <p-checkbox #Roles
                                      name="resetallpasswords"
                                      value="Y"
                                      label="Reset All Passwords"
                                      binary="true"
                                      formControlName="resetAllPasswords"></p-checkbox>
                      </div>
                  </ng-container>
                <div class="field col-12 md:col-3" *ngIf="enableEmergencyToken">
                    <p-checkbox #Roles
                                name="emergencytoken"
                                value="Y"
                                label="Emergency Token"
                                binary="true"
                                formControlName="emergencyToken"></p-checkbox>
                </div>
            </div>




            <!--</p-panel>-->
            <!--<p-panel header="Patient " [toggleable]="true">-->
            <h5 class="col-3 md:col-3 lg:col-2 xl:col-2 blueBar mb-4 pl-3 r-2">Patient</h5>
            <div class="p-fluid formgrid grid ml-5">
                <!--</div>-->
                <div class="field col-12 md:col-3">
                    <p-checkbox #Roles
                                name="allergies"
                                value="Y"
                                label="Allergy "
                                binary="true"
                                formControlName="allergies"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3">
                    <p-checkbox #Roles
                                name="problems"
                                value="Y"
                                label="Problems"
                                binary="true"
                                formControlName="problems"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3">
                    <p-checkbox #Roles
                                name="medication"
                                value="Y"
                                label="Medication"
                                binary="true"
                                formControlName="medication"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3">
                    <p-checkbox #Roles
                                name="visits"
                                value="Y"
                                label="Visits"
                                binary="true"
                                formControlName="visits"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3" *ngIf="showPatientImage">
                    <p-checkbox #Roles
                                name="images"
                                value="Y"
                                label="Images"
                                binary="true"
                                formControlName="images"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3" *ngIf="showPatientDocuments">
                    <p-checkbox #Roles
                                name="documents"
                                value="Y"
                                label="Documents"
                                binary="true"
                                formControlName="documents"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3">
                    <p-checkbox #Roles
                                name="labs"
                                value="Y"
                                label="Labs"
                                binary="true"
                                formControlName="labs"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3">
                    <p-checkbox #Roles
                                name="orders"
                                value="Y"
                                label="Orders"
                                binary="true"
                                formControlName="orders"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3">
                    <p-checkbox #Roles
                                name="vitals"
                                value="Y"
                                label="Vitals"
                                binary="true"
                                formControlName="vitals"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3" *ngIf="showExportDocuments">
                    <p-checkbox #Roles
                                name="exportdocuments"
                                value="Y"
                                label="Export Documents"
                                binary="true"
                                formControlName="exportdocuments"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3" *ngIf="showPatientNotes">
                    <p-checkbox #Roles
                                name="notes"
                                value="Y"
                                label="Notes"
                                binary="true"
                                formControlName="notes"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3" *ngIf="enableBilling">
                    <p-checkbox #Roles
                                name="charge"
                                value="Y"
                                label="Charge"
                                binary="true"
                                formControlName="charge"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3" *ngIf="showFinancialSummary">
                    <p-checkbox #Roles
                                name="financialSummary"
                                value="Y"
                                label="Financial Summary"
                                binary="true"
                                formControlName="financialSummary"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3" *ngIf="showSignificantEvent">
                    <p-checkbox #Roles
                                name="significantEvents"
                                value="Y"
                                label="Significant Events"
                                binary="true"
                                formControlName="significantEvents"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3" *ngIf="showRestoreTabToUser">
                    <p-checkbox #Roles
                                name="showRestoreTabToUser"
                                value="Y"
                                label="Patient Restore"
                                binary="true"
                                formControlName="showRestoreTabToUser"></p-checkbox>
                </div>

                <div class="field col-12 md:col-3" *ngIf="showSensitiveData && isGlobalAdmin">

                    <p-checkbox #Roles
                                name="showSensitiveData"
                                value="Y"
                                label="Show Sensitive Data"
                                binary="true"
                                formControlName="showSensitiveData"></p-checkbox>
                </div>



                <div class="field col-12 md:col-3" *ngIf="showPatientDemographicPrint">
                    <p-checkbox #Roles name="patientRecordsPrint" value="Y" label="Print Patient Data" binary="true" formControlName="patientRecordsPrint"></p-checkbox>
                </div>

                <div class="field col-12 md:col-3" *ngIf="enableDocumentDownloads">
                    <p-checkbox #Roles name="enableDocumentDownloads" value="Y" label="Download Documents" binary="true" formControlName="enableDocumentDownloads"></p-checkbox>
                </div>
                <div class="field col-12 md:col-3" *ngIf="showPatientDemographics">
                    <p-checkbox #Roles
                                name="managePatientDemographic"
                                value="Y"
                                label="Edit Patient Demographics"
                                binary="true"
                                formControlName="managePatientDemographic"></p-checkbox>
                </div>

                <div class="field col-12 md:col-3" *ngIf="showPatientPayer">
                    <p-checkbox #Roles
                                name="managePatientPayer"
                                value="Y"
                                label="Add Patient Payor"
                                binary="true"
                                formControlName="managePatientPayer"></p-checkbox>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="p-fluid formgrid grid">
                <div class="col-2 md:col-2 mt-2 mb-2 ml-2">
                    <button pButton
                            type="submit"
                            label="Save"
                            icon="pi pi-save"
                            class="p-button-plain buttonWidth-8 fl"></button>
                </div>
            </div>
        </div>
    </form>
</div>
